export const GET_EXHIBITOR_FORM_BY_TOKEN = `
  query getExhibitorFormByToken($token: String!) {
    getExhibitorFormByToken(token: $token) {
      __typename
      ... on ExhibitorFormData {
        token_status
        provinces {
          id
          name
          active
        }
        contact {
          id
          firstname
          lastname
          email
          phone
          mobile
          birth_date
          city
          zip_code
          province
          address
          profile_picture_id
        }
        exhibitor {
          id
          status
          roaming
          roaming_provinces
          pay
          pay_virtual
          pay_virtual_short
          linkedin
          referred_by
          curriculum_vitae
          company_name
          cuit
          iva_condition
          bank
          bank_account_type
          branch_office
          branch_office_number
          account_holder
          cbu
        }
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
